export default __webpack_public_path__ + "static/media/2313.14d4aa50.png";